if (!customElements.get('toasty-day-journal')) {
  customElements.define('toasty-day-journal', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const cards = [...this.querySelectorAll('.tt-day__panel')];
      const prints = cards.map(card => card.querySelector('.tt-day__print'));
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      let frame = 0, lastScroll = scrollY, lastTrigger = 0, visible = false, touching = false;
      this.stop = () => { cancelAnimationFrame(frame); frame = 0; prints.forEach(print => { print.style.removeProperty('--j'); print.style.removeProperty('--y'); }); };
      const jiggle = () => {
        if (reduced.matches || touching || !visible) return;
        this.stop();
        const start = performance.now();
        const tick = now => {
          const age = now - start;
          if (age >= 550) { this.stop(); return; }
          prints.forEach((print, i) => {
            if (cards[i].matches(':focus-within') || (matchMedia('(hover: hover)').matches && cards[i].matches(':hover'))) return;
            const wave = Math.sin(age / 65 + i * .6) * (1 - age / 550);
            print.style.setProperty('--j', `${wave * .38}deg`);
            print.style.setProperty('--y', `${wave * 1.1}px`);
          });
          frame = requestAnimationFrame(tick);
        };
        frame = requestAnimationFrame(tick);
      };
      this.observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; if (!visible) this.stop(); });
      this.observer.observe(this);
      addEventListener('scroll', () => { if (Math.abs(scrollY - lastScroll) > 3 && performance.now() - lastTrigger > 170) { lastTrigger = performance.now(); jiggle(); } lastScroll = scrollY; }, { ...options, passive: true });
      cards.forEach(card => {
        card.addEventListener('pointerdown', () => { touching = true; this.stop(); }, options);
        card.addEventListener('focusin', this.stop, options);
      });
      for (const event of ['pointerup', 'pointercancel']) addEventListener(event, () => { touching = false; }, options);
      reduced.addEventListener('change', this.stop, options);
    }
    disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); this.stop?.(); }
  });
}
